import React, { Component } from 'react';
import {connect, actions} from 'mirrorx';

import DropboxController from '../controllers/dropbox-controller';
import Pages from '../enums/pages';


import { Scrollbars } from 'react-custom-scrollbars';

class Tutorial extends Component {
	constructor() {
		super();
		this.controller = null;
	}
	onClick() {
		actions.layout.setPage(Pages.TEXTAREA);
	}

	onAuthenticate = () => {
		if (!this.controller) {
			return;
		}
		this.controller.authenticate();
	}

	isAuthenticated = () => {
		if (!this.controller) {
			return false;
		}
		return this.controller.isAuthenticated();
	}

	initializeController = () => {
		if (this.controller == null) {
			this.controller = new DropboxController(this.props.services.dropboxClientId);
		}
	}

	componentDidMount() {
		this.initializeController();
	}

	renderBottomButton() {
		if (this.isAuthenticated()) {
			return <button className='btn' onClick={this.onClick}>Got it!</button>;
		}
		return <div>
			<p>RUNE requires a Dropbox connection to save and load files.</p>
			<button className='btn' onClick={this.onAuthenticate}>Connect to Dropbox</button>
		</div>
	}
	render() {
		return (
			<Scrollbars>
				<div style={{maxWidth: '640px'}}>
				<h1>RUNE</h1>
				<p>A Dropbox-powered web text editor with multiple export options.</p>
				<hr />
				<h2>Controls</h2>
				<ul>
				<li>Start a line with '# ', '## ', or '. ' (no quotes) to create a heading.</li>
				<li>Alt-N: create a new file. (The editor cannot listen to Ctrl-N)</li>
				<li>Ctrl-O or Alt-O: open a file from Dropbox.</li>
				<li>Ctrl-S or Alt-S: save a file to Dropbox.</li>
				<li>Ctrl-Shift-S or Alt-Shift-S: save a new file to Dropbox</li>
				</ul>
				<p>Click the logo on the top right to open the right filebar, which contains a list of recent files.</p>
				<p>Use the tabs on the left sidebar to switch between the heading navigator, basic file commands, and the export options.</p>
				<hr />
				{ this.renderBottomButton() }
				</div>
			</Scrollbars>
		)
	}
}

export default connect(state => {
  return {services: state.services}
})(Tutorial);


// WEBPACK FOOTER //
// ./src/components/tutorial-page.js